import {ACTION_CODE} from './_actionCode';
import {ServicesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'GET_ALL_SERVICES';

export async function getAllServices(token = "", params = "", page = 1) {
    try {
        LoggerService.logInfo('Action - getAllServices - Start');

        const result = await ServicesService.getAllServices(token, params, page);

        const {data, metadata} = result;

        LoggerService.logInfo('Action - getAllServices - Success');

        return ResultModel.newSuccessResult(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllServices - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des services',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
